import { styled } from "@vitality-ds/system";
import BaseRemoveButtonButtonStyles from "./styles/BaseRemoveButtonButton.styles";
import BaseRemoveButtonContainerStyles from "./styles/BaseRemoveButtonContainer.styles";
export var BaseRemoveButtonContainer = styled("div", BaseRemoveButtonContainerStyles);
export var BaseRemoveButtonButton = styled("button", BaseRemoveButtonButtonStyles);